// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__ru5Xh","invalid":"Textarea_invalid__S9WuG","textareaLimit":"Textarea_textareaLimit__aGJxb"};